// extracted by css-extract-rspack-plugin
export default {"overflowEllips":"DeleteTd__overflowEllips--r_rrY","active":"DeleteTd__active--OlbEy","disabled":"DeleteTd__disabled--vY0ol","note":"DeleteTd__note--DbSoW"};